import React from 'react'
import TextInput from '../../../components/UIComponent/TextInput'
import ExpandableGroup from '../../../components/ExpandableGroup'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons'
import DateRangeField from '../../../components/dateRangeField/DateRangeField'
import ToggleSwitch from '../../../components/common/ToggleSwitch'

function BalanceSheetUI(props) {
    const safeAmount = (val) => (Number(val) || 0).toLocaleString("en-IN");
    return (
        <div className='balancesheet bg-white rounded-[10px] border-2 border-gray-200 overflow-hidden'>

            <div className='search-area px-2.5 py-[10px] border-b-2 border-gray-100'>
                <div className='grid grid-cols-[0.8fr_0.8fr_0.5fr_1fr] gap-4'>
                    <div className="input-grp">
                        <label>From Date</label>
                        <TextInput
                            type="date"
                            id="fromDate"
                            name="fromDate"
                            value={props.balanceObject.fromDate}
                            handleChange={(event) => props.handleChange(event, "fromDate")}
                            className={props.validState?.error?.fromDate ? "error" : ""}
                        />
                    </div>

                    <div className="input-grp">
                        <label>To Date</label>
                        <TextInput
                            type="date"
                            id="toDate"
                            name="toDate"
                            value={props.balanceObject.toDate}
                            handleChange={(event) => props.handleChange(event, "toDate")}
                            className={props.validState?.error?.toDate ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp flex gap-[10px] items-center pt-5'>
                        <label>Include Zero Values:</label>
                        <ToggleSwitch
                            checked={props.balanceObject.includeZero}
                            onChange={(e) => props.handleChange(e, "includeZero")}
                        />
                    </div>
                    <div className='btn-grp mt-5'>
                        <button
                            onClick={() => props.getBalanceSheetReport()}
                            className='prm-btn'>Search</button>
                    </div>
                </div>
            </div>

            <div className='report-area p-2.5 overflow-hidden overflow-y-auto'
                style={{ maxHeight: "calc(100dvh - 235px)", height: "100%" }}
            >
                <div className='grid grid-cols-2 gap-2.5'>

                    <div className='assets bg-green-50 rounded-lg border border-green-200 overflow-hidden h-fit'>
                        <div className='px-4 py-[8px] border-b border-green-200 flex items-center justify-between'>
                            <h2 className='text-[18px] font-semibold text-green-900'>
                                Assets
                            </h2>
                            <p className='text-[16px] text-green-900 font-normal'>Total: <span className='font-semibold'>₹ {safeAmount(Math.abs(props.balanceSheetData.totalAssets))}</span></p>
                        </div>

                        <div className='p-2.5 space-y-2'>
                            {props.balanceSheetData?.assets.map((group, index) => (
                                <ExpandableGroup
                                    key={index}
                                    {...group}
                                    theme="green"
                                    onItemClick={(item) => props.redirectToLedger(item)}
                                />
                            ))}
                        </div>
                    </div>

                    <div className='liabilities bg-orange-50 rounded-lg border border-orange-200 overflow-hidden h-fit'>
                        <div className='px-4 py-[8px] border-b border-orange-200 flex items-center justify-between'>
                            <h2 className='text-[18px] font-semibold text-orange-900'>
                                Liabilities
                            </h2>
                            <p className='text-[16px] text-orange-900 font-normal'>Total: <span className='font-semibold'>₹ {safeAmount(Math.abs(props.balanceSheetData.totalLiabilities))}</span></p>
                        </div>

                        <div className='p-2.5 space-y-2'>
                            {props.balanceSheetData?.liabilities.map((group, index) => (
                                <ExpandableGroup
                                    key={index}
                                    {...group}
                                    theme="orange"
                                    onItemClick={(item) => props.redirectToLedger(item)}
                                />
                            ))}
                        </div>
                    </div>
                </div>

            </div>

            <div className='flex items-center gap-3 p-2.5 border-t-2 border-gray-100 bg-red-50'>
                <div className='w-[25px] h-[25px] bg-red-500 rounded-md flex items-center justify-center'>
                    <FontAwesomeIcon
                        icon={faTriangleExclamation}
                        className='text-white text-[14px]'
                    />
                </div>

                <p className='text-[14px] font-medium text-red-700'>
                    Difference in Balance Sheet:
                    <span className='font-semibold ml-1'> ₹ {safeAmount(
                        Math.abs(props.balanceSheetData.totalAssets) - Math.abs(props.balanceSheetData.totalLiabilities)
                    )}</span>
                </p>
            </div>
        </div>
    )
}

export default BalanceSheetUI
